var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 0H3.75C1.6875 0 0 1.6875 0 3.75V28.25C0 30.3125 1.6875 32 3.75 32H16.83V19.7375H13V14.8H16.83V11.2119C16.83 7.18313 18.8019 4.7875 23.3394 4.7875H27.1169V9.72625H24.2569C22.49 9.72625 22.3725 10.4162 22.3725 11.7037L22.3662 14.8H26.895L26.2687 19.7375H22.3662V32H28.25C30.3125 32 32 30.3125 32 28.25V3.75C32 1.6875 30.3125 0 28.25 0Z",
    fill: "#16449A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2694 19.7376L26.8956 14.8001H22.3669L22.3731 11.7038C22.3731 10.4163 22.4906 9.72634 24.2575 9.72634H27.1175V4.7876H23.34C18.8019 4.7876 16.8306 7.18322 16.8306 11.212V14.8001H13V19.7376H16.83V32.0001H22.3662V19.7376H26.2694Z",
    fill: "#ECF0FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.69496d30f9603e17ccd6cad1221dcbb6.svg";
export { ForwardRef as ReactComponent };